// import lipstick prototype object
import { LipstickProduct } from '@facecake/fmt-react-tryon/';

// load array of glasses products
const lipsticks = [
  { 
    brandName: 'Brand 1',
    productName: 'Lipstick 1',
    price: '$-.--',
    productPdpUrl: 'http://www.pntra.com/t/TUJGRkVMTEJGRk5NSEpCRklITE5N?url=https%3A%2F%2Fwww.baublebar.com%2Fproduct%2F29790-crispin-drops-earrings.html',
    productThumb: {
      unselected: 'https://demos.facecake.com/CES2019/images/products/glasses/thumb_glasses_wayfarer.png',
      selected: 'https://demos.facecake.com/CES2019/images/products/glasses/thumb_glasses_wayfarer_over.png',
    },
    lipstickProduct: new LipstickProduct({
      productId: 1,
      colorHex: '0xFF0000',
    }),
  }, { 
    brandName: 'Brand 2',
    productName: 'Lipstick 2',
    price: '$-.--',
    productPdpUrl: 'http://www.anrdoezrs.net/links/7568311/type/dlg/https://www.kendrascott.com/jewelry/categories/earrings/842177093962.html',
    productThumb: {
      unselected: 'https://demos.facecake.com/CES2019/images/products/glasses/thumb_glasses_caravan.png',
      selected: 'https://demos.facecake.com/CES2019/images/products/glasses/thumb_glasses_caravan_over.png',
     },
    lipstickProduct: new LipstickProduct({
      productId: 2,
      colorHex: '0x00FF00',
    }),
  }, { 
    brandName: 'Brand 3',
    productName: 'Lipstick 3',
    price: '$-.--',
    productPdpUrl:'http://www.gopjn.com/t/TUJGRkVMTEJGRk5NSEpCRklITE5N?url=https%3A%2F%2Fwww.baublebar.com%2Fproduct%2F39400-tahir-drop-earrings',
    productThumb: {
      unselected: 'https://demos.facecake.com/CES2019/images/products/glasses/thumb_glasses_toriBurch.png',
      selected: 'https://demos.facecake.com/CES2019/images/products/glasses/thumb_glasses_toriBurch_over.png',
    },
    lipstickProduct: new LipstickProduct({
      productId: 3,
      colorHex: '0x0000FF',
    }),
  }, { 
    brandName: 'Brand 4',
    productName: 'Lipstick 4',
    price: '$-.--',
    productPdpUrl: 'http://www.pntrac.com/t/TUJGRkVMTEJGRk5NSEpCRklITE5N?url=https%3A%2F%2Fwww.baublebar.com%2Fproduct%2F34817-sydney-hoop-earrings%3Fsku%3D34817',
    productThumb: {
      unselected: 'https://demos.facecake.com/CES2019/images/products/glasses/thumb_glasses_gucci.png',
      selected: 'https://demos.facecake.com/CES2019/images/products/glasses/thumb_glasses_gucci_over.png',
    },
    lipstickProduct: new LipstickProduct({
      productId: 4,
      colorHex: '0xFF0000',
    }),
  },
];

export default lipsticks;